import { RatingSlider } from "../PostPollRate.styles";
import { MAX_RATING, MIN_RATING } from "./PostPollRateSection";
import { SliderThumb } from "@mui/material/Slider";
import { ReactionLikeIcon } from "@icons/ReactionLikeIcon";
import { TIPPSPIEL_BOX_SHADOW } from "../../../../../../styles";
import { PollOption } from "@infrastructure/Services/PostService.types";
import { HTMLAttributes, useCallback, useState } from "react";
import debounce from "lodash/debounce";

export function BeforeRatingSlider({
    handlePollOptionClick,
    pollOptions,
    open,
}: {
    handlePollOptionClick: (
        pollOptionId: number,
        type: "create" | "delete",
    ) => void;
    open: boolean;
    pollOptions: PollOption[];
}) {
    const [value, setValue] = useState(0);
    const debouncedSetSearchString = useCallback(
        debounce((value: { action: "create" | "delete"; id: number }) => {
            handlePollOptionClick(value.id, value.action);
        }, 1000),
        [],
    );

    return (
        <RatingSlider
            onChange={(event, newValue) => setValue(newValue as number)}
            value={value}
            disableSwap={!open}
            min={MIN_RATING}
            max={MAX_RATING}
            slots={{
                thumb: LikeThumbComponent,
            }}
            onChangeCommitted={(event, value) => {
                pollOptions.findIndex((option) => {
                    if (option.content === value.toString()) {
                        debouncedSetSearchString({
                            id: option.id,
                            action: "create",
                        });
                        return true;
                    }
                    return false;
                });
            }}
        />
    );
}

export function LikeThumbComponent(props: HTMLAttributes<unknown>) {
    const { children, ...other } = props;
    return (
        <SliderThumb {...other}>
            {children}
            <ReactionLikeIcon
                width="100%"
                height="100%"
                boxShadow={TIPPSPIEL_BOX_SHADOW}
                borderRadius="90px"
            />
        </SliderThumb>
    );
}
